import * as React from 'react';

const bigBackground = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1440 152"
    fill="none"
    preserveAspectRatio="xMidYMid slice"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="url(#b)" d="M0 0h1440v152H0z" />
      <path
        fill="#926FE5"
        d="M1123.5 72c210.29-96.93 381.83-197.167 462.5-202h51.5v306.5L409 165.5c185-14 458.5 24.5 714.5-93.5Z"
        opacity={0.2}
      />
      <path
        fill="#926FE5"
        d="M1206.5 98C1416.79 1.07 1588.33-99.167 1669-104h51.5v306.5L492 191.5c185-14 458.5 24.5 714.5-93.5Z"
        opacity={0.2}
      />
      <path
        fill="#926FE5"
        d="M236 72C25.71-24.93-145.833-125.167-226.5-130H-278v306.5l1228.5-11C765.5 151.5 492 190 236 72Z"
        opacity={0.2}
      />
      <path
        fill="#926FE5"
        d="M153 98C-57.29 1.07-228.833-99.167-309.5-104H-361v306.5l1228.5-11C682.5 177.5 409 216 153 98Z"
        opacity={0.2}
      />
    </g>
    <defs>
      <linearGradient id="b" x1={0} x2={1440} y1={76} y2={76} gradientUnits="userSpaceOnUse">
        <stop stopColor="#E6E3FC" />
        <stop offset={1} stopColor="#B6ACF5" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h1440v152H0z" />
      </clipPath>
    </defs>
  </svg>
);

const smallBackground = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 360 80"
    fill="none"
    preserveAspectRatio="xMidYMid slice"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#E6E3FC" d="M0 0h360v80H0z" />
      <path
        fill="#926FE5"
        d="M240.775 55.292C304.281 25.881 356.086-4.533 380.447-6H396v93L25 83.662c55.869-4.248 138.464 7.434 215.775-28.37Z"
        opacity={0.2}
      />
      <path
        fill="#926FE5"
        d="M260.775 75.292C324.281 45.881 376.086 15.467 400.447 14H416v93l-371-3.338c55.869-4.248 138.464 7.434 215.775-28.37Z"
        opacity={0.2}
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h360v80H0z" />
      </clipPath>
    </defs>
  </svg>
);

export { bigBackground, smallBackground };
